<template>
    <a-modal v-model="filterVisible" title="指标信息" :footer="null" :centered="true">
        <div v-if="infomation!==null">
            <a-row type="flex" :gutter="[16,16]">
                <a-col flex="60px">名称</a-col>
                <a-col flex="auto">{{infomation.dimFName}}</a-col>
            </a-row>
            <a-row type="flex" :gutter="[16,16]">
                <a-col flex="60px">来源</a-col>
                <a-col flex="auto">{{infomation.dimSource}}</a-col>
            </a-row>
            <a-row type="flex" :gutter="[16,16]">
                <a-col flex="60px">机构</a-col>
                <a-col flex="auto">{{infomation.org}}</a-col>
            </a-row>
            <a-row type="flex" :gutter="[16,16]" v-show="infomation.dimComment">
                <a-col flex="60px">说明</a-col>
                <a-col flex="auto">{{infomation.dimComment}}</a-col>
            </a-row>
            <a-row type="flex" :gutter="[16,16]" v-show="timeRange">
                <a-col flex="60px">时间</a-col>
                <a-col flex="auto">{{timeRange}}</a-col>
            </a-row>
        </div>
    </a-modal>
</template>

<script>
export default {
    name:'IndicatorInfo',
    props:['visible','params','freqId'],
    data() {
        return {
            filterVisible:false,
            infomation:null,
            timeRange:''
        }
    },
    watch:{
        visible(value) {
            if(value) {                
                this.filterVisible = true;
                this.infomation = null;
                let params = {
                    dimCode:this.params.obj,
                    cubeId:this.params.cubeId,
                    dimType:'INDICATOR'
                }
                this.$http.getDimInfo(params).then(res=>{
                    if(res&&res.information) {
                        this.infomation = res.information;
                        if(res.information.startDate&&res.information.lastDate) {
                            if(this.freqId===1) {
                                this.timeRange = res.information.startDate.substring(0,4)+'——'+res.information.lastDate.substring(0,4)
                            } else if(this.freqId===4) {
                                this.timeRange = res.information.startDate.substring(0,7)+'——'+res.information.lastDate.substring(0,7)
                            } else {
                                let year1 = res.information.startDate.substring(0,4);
                                let year2 = res.information.lastDate.substring(0,4);
                                let quarter1 = Math.floor((parseInt(res.information.startDate.substring(5,7))-1)/3);
                                let quarter2 = Math.floor((parseInt(res.information.lastDate.substring(5,7))-1)/3);
                                let quarters = ['Ⅰ','Ⅱ','Ⅲ','Ⅳ'];
                                this.timeRange = quarters[quarter1]+'-'+year1+'——'+quarters[quarter2]+'-'+year2;
                            }
                        }
                    }
                });
            } else {
                this.filterVisible = false;
            }
        }
    },
}
</script>